import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Start.css';

function BasicInfoForm() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    department: '',
    postalCode: '',
    address: '',
    phone: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 前端验证必填字段
    if (!formData.name.trim()) {
      alert('名前を入力してください。');
      return;
    }

    setIsLoading(true);
    const token = localStorage.getItem('access_token');

    try {
      const response = await fetch('https://api.nagae.biz/api/newinfo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: formData.name,
          company: formData.company,
          department: formData.department,
          postal_code: formData.postalCode,
          address: formData.address,
          phone: formData.phone,
        }),
      });

      if (response.ok) {
        const basicInfo = {
          name: formData.name,
          businessType: formData.businessType,
        };
        sessionStorage.setItem('basicinfo', JSON.stringify(basicInfo));
        navigate('/start');
      } else {
        alert("データ送信に失敗しました。");
      }
    } catch (error) {
      console.error("Error during fetch:", error);
      alert("通信エラーが発生しました。");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-container">
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <header className="header">
        <div className="logo">
          <h1></h1>
          <p className="subtitle" style={{ marginBottom: '10px' }}></p>
        </div>
      </header>
      <main className="main-content">
        <section id="business-info-screen" className="screen active">
          <div 
            className="card" 
            style={{ 
              marginTop: '-85px', 
              position: 'relative', 
              paddingBottom: '80px',
              maxWidth: '750px',
              margin: '-100px auto 0',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <h2 className="section-title">基本情報入力</h2>
            <p className="info-text">必要な基本情報を入力してください。</p>
            <form 
              className="form-container" 
              onSubmit={handleSubmit}
              style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%' }}
            >
              <div className="form-group">
                <label htmlFor="name">
                  名前
                  <span style={{ color: 'red', marginLeft: '5px' }}>必須</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="山田 太郎"
                  required
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="company">会社名</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  className="form-input"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="株式会社サンプル"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="department">部署</label>
                <input
                  type="text"
                  id="department"
                  name="department"
                  className="form-input"
                  value={formData.department}
                  onChange={handleChange}
                  placeholder="営業部"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="postalCode">郵便番号</label>
                <input
                  type="text"
                  id="postalCode"
                  name="postalCode"
                  className="form-input"
                  value={formData.postalCode}
                  onChange={handleChange}
                  placeholder="123-4567"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="address">ご住所</label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  className="form-input"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="東京都千代田区1-2-3"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">電話番号</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  className="form-input"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="03-1234-5678"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ height: '80px' }}></div>
            </form>
            <div 
              className="button-container" 
              style={{ position: 'absolute', bottom: '20px', right: '20px' }}
            >
              <button 
                type="submit" 
                className="btn btn-primary" 
                disabled={isLoading} 
                onClick={handleSubmit}
              >
                {isLoading ? "送信中..." : "次へ"}
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default BasicInfoForm;
